<div class="pr-1 req-access-heading">
  {{ 'broker.compensation.requestaccess.requestStmtTitle' | translate }}
</div>
<div class="pt-1 req-access-info">
  {{ 'broker.compensation.requestaccess.compReqestAccessText' | translate }}

  {{ 'broker.compensation.requestaccess.reqAccessHelp' | translate }}
  <strong
    ><a
      *ngIf="!isImpersonatorFlag"
      class="msg-high-color"
      href="{{
        'broker.compensation.requestaccess.reqAccessHelpEmail' | translate
      }}"
      (click)="trackLinkClick()"
    >
      {{
        'broker.compensation.requestaccess.reqAccessHelpEmailLabel' | translate
      }}
    </a>
    <a class="disabled-link" *ngIf="isImpersonatorFlag">
      {{
        'broker.compensation.requestaccess.reqAccessHelpEmailLabel' | translate
      }}
    </a>
  </strong>

  {{ 'broker.compensation.requestaccess.reqAccessEmailRole' | translate }}
</div>
